export default __webpack_public_path__ + "static/media/close-button.de0c80df.png";